import { Box, useTheme } from '@mui/material';

import { Skeleton } from '@/components';

import {
  LearningPathCardDimensions,
  LearningPathCardVariants,
} from './constants';

type LearningPathCardVariant =
  (typeof LearningPathCardVariants)[keyof typeof LearningPathCardVariants];

const { width: verticalWidth, height: verticalHeight } =
  LearningPathCardDimensions[LearningPathCardVariants.VERTICAL];
const { height: horizontalHeight, heightLarge: horizontalHeightLarge } =
  LearningPathCardDimensions[LearningPathCardVariants.HORIZONTAL];
const { height: listHeight } =
  LearningPathCardDimensions[LearningPathCardVariants.LIST];

const HORIZONTAL_LARGE_BREAKPOINT = 580;

export const LearningPathCardSkeleton = ({
  variant = LearningPathCardVariants.VERTICAL,
  stretch = false,
}: {
  variant?: LearningPathCardVariant;
  stretch?: boolean;
}) => {
  const { containerQueries } = useTheme();

  if (variant === LearningPathCardVariants.HORIZONTAL) {
    return (
      <Box
        sx={{
          width: '100%',
          height: horizontalHeight,
          [containerQueries.up(HORIZONTAL_LARGE_BREAKPOINT)]: {
            height: horizontalHeightLarge,
          },
        }}>
        <Skeleton
          variant="rounded"
          width="100%"
          height="100%"
          sx={{ borderRadius: 4 }}
        />
      </Box>
    );
  }

  if (variant === LearningPathCardVariants.LIST) {
    return (
      <Box sx={{ width: '100%', height: listHeight }}>
        <Skeleton
          variant="rounded"
          width="100%"
          height="100%"
          sx={{ borderRadius: 2 }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: '100%',
        width: stretch ? '100%' : verticalWidth,
        maxWidth: stretch ? '100%' : verticalWidth,
        maxHeight: stretch ? 'none' : verticalHeight,
        aspectRatio: `${verticalWidth} / ${verticalHeight}`,
      }}>
      <Skeleton
        variant="rounded"
        width="100%"
        height="100%"
        sx={{ borderRadius: 4 }}
      />
    </Box>
  );
};
